// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Talent List Container */
.scl--web-component-talent-list-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 27px;
  width: 100%;
}

/* Talent Step Item */
.scl--web-component-talent-step-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 377px;
  width: 100%;
  min-height: 116px;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

/* Step Number */
.scl--web-component-talent-step-number {
  position: relative;
  width: 114px;
  min-width: 114px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #7D8187;
  flex: none;
  order: 0;
  flex-grow: 0;
}

/* Content Wrapper */
.scl--web-component-talent-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  width: 635px;
  min-height: 116px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

/* Title */
.scl--web-component-talent-title {
  width: 100%;
  max-width: 635px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

/* Description */
.scl--web-component-talent-description {
  width: 100%;
  max-width: 635px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #7D8187;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

/* Hide description if empty */
.scl--web-component-talent-description:empty {
  display: none;
}

/* Button */
.scl--web-component-talent-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 11px;
  min-width: 134px;
  height: 40px;
  border: 1.5px solid #797979;
  border-radius: 20px;
  background: transparent;
  cursor: pointer;
  flex: none;
  order: 2;
  flex-grow: 0;
  transition: all 0.2s ease;
}

.scl--web-component-talent-button:hover {
  border-color: #FFFFFF;
}

/* Button Text */
.scl--web-component-talent-button-text {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  background: linear-gradient(269.77deg, #FFFFFF 33.81%, #ADADAD 89.95%, #DDDDDD 126.9%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  flex: none;
  order: 0;
  flex-grow: 0;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .scl--web-component-talent-step-item {
    gap: 200px;
  }

  .scl--web-component-talent-content {
    width: 500px;
  }

  .scl--web-component-talent-title,
  .scl--web-component-talent-description {
    width: 500px;
  }
}

@media (max-width: 1024px) {
  .scl--web-component-talent-step-item {
    gap: 100px;
  }

  .scl--web-component-talent-step-number {
    width: 100px;
    min-width: 100px;
  }

  .scl--web-component-talent-content {
    width: 450px;
  }

  .scl--web-component-talent-title,
  .scl--web-component-talent-description {
    width: 450px;
  }
}

@media (max-width: 768px) {
  .scl--web-component-talent-step-item {
    flex-direction: column;
    gap: 15px;
  }

  .scl--web-component-talent-step-number {
    width: 100%;
  }

  .scl--web-component-talent-content {
    width: 100%;
  }

  .scl--web-component-talent-title,
  .scl--web-component-talent-description {
    width: 100%;
  }

  .scl--web-component-talent-title {
    font-size: 20px;
  }

  .scl--web-component-talent-description {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .scl--web-component-talent-list-container {
    gap: 20px;
  }

  .scl--web-component-talent-content {
    gap: 15px;
  }

  .scl--web-component-talent-title {
    font-size: 18px;
    line-height: 26px;
  }

  .scl--web-component-talent-description {
    font-size: 14px;
    line-height: 24px;
  }

  .scl--web-component-talent-button {
    width: 120px;
    height: 36px;
  }

  .scl--web-component-talent-button-text {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/list/talents/css/talent.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sFAAsF;EACtF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Talent List Container */\n.scl--web-component-talent-list-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 27px;\n  width: 100%;\n}\n\n/* Talent Step Item */\n.scl--web-component-talent-step-item {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 377px;\n  width: 100%;\n  min-height: 116px;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* Step Number */\n.scl--web-component-talent-step-number {\n  position: relative;\n  width: 114px;\n  min-width: 114px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #7D8187;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n/* Content Wrapper */\n.scl--web-component-talent-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 10px;\n  width: 635px;\n  min-height: 116px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n/* Title */\n.scl--web-component-talent-title {\n  width: 100%;\n  max-width: 635px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 30px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.01em;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* Description */\n.scl--web-component-talent-description {\n  width: 100%;\n  max-width: 635px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 30px;\n  display: flex;\n  align-items: center;\n  color: #7D8187;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* Hide description if empty */\n.scl--web-component-talent-description:empty {\n  display: none;\n}\n\n/* Button */\n.scl--web-component-talent-button {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 11px;\n  min-width: 134px;\n  height: 40px;\n  border: 1.5px solid #797979;\n  border-radius: 20px;\n  background: transparent;\n  cursor: pointer;\n  flex: none;\n  order: 2;\n  flex-grow: 0;\n  transition: all 0.2s ease;\n}\n\n.scl--web-component-talent-button:hover {\n  border-color: #FFFFFF;\n}\n\n/* Button Text */\n.scl--web-component-talent-button-text {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  background: linear-gradient(269.77deg, #FFFFFF 33.81%, #ADADAD 89.95%, #DDDDDD 126.9%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n  .scl--web-component-talent-step-item {\n    gap: 200px;\n  }\n\n  .scl--web-component-talent-content {\n    width: 500px;\n  }\n\n  .scl--web-component-talent-title,\n  .scl--web-component-talent-description {\n    width: 500px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .scl--web-component-talent-step-item {\n    gap: 100px;\n  }\n\n  .scl--web-component-talent-step-number {\n    width: 100px;\n    min-width: 100px;\n  }\n\n  .scl--web-component-talent-content {\n    width: 450px;\n  }\n\n  .scl--web-component-talent-title,\n  .scl--web-component-talent-description {\n    width: 450px;\n  }\n}\n\n@media (max-width: 768px) {\n  .scl--web-component-talent-step-item {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .scl--web-component-talent-step-number {\n    width: 100%;\n  }\n\n  .scl--web-component-talent-content {\n    width: 100%;\n  }\n\n  .scl--web-component-talent-title,\n  .scl--web-component-talent-description {\n    width: 100%;\n  }\n\n  .scl--web-component-talent-title {\n    font-size: 20px;\n  }\n\n  .scl--web-component-talent-description {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .scl--web-component-talent-list-container {\n    gap: 20px;\n  }\n\n  .scl--web-component-talent-content {\n    gap: 15px;\n  }\n\n  .scl--web-component-talent-title {\n    font-size: 18px;\n    line-height: 26px;\n  }\n\n  .scl--web-component-talent-description {\n    font-size: 14px;\n    line-height: 24px;\n  }\n\n  .scl--web-component-talent-button {\n    width: 120px;\n    height: 36px;\n  }\n\n  .scl--web-component-talent-button-text {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
